import type {
  CreateTreatmentPlanTemplateRequest,
  InterventionGroupTemplateRequest,
  InterventionGroupTemplateResponse,
  InterventionTemplateRequest,
  InterventionTemplateResponse,
  TreatmentPlanTemplateResponse,
  TreatmentWeekTemplateRequest,
  TreatmentWeekTemplateResponse
} from '../api/generated';

function interventionResponseToCloneRequest(
  iv: InterventionTemplateResponse
): InterventionTemplateRequest {
  return {
    id: iv.id,
    name: iv.name,
    description: iv.description,
    color: iv.color,
    icon: iv.icon,
    durationMinutes: iv.durationMinutes,
    sessionType: iv.sessionType,
    mandatoryStaffCompetenceRequirements: iv.mandatoryStaffCompetenceRequirements,
    flexStaffCompetenceRequirements: iv.flexStaffCompetenceRequirements,
    allowedDays: iv.allowedDays,
    roomRequirements: iv.roomRequirements
  };
}

function groupResponseToRequest(
  g: InterventionGroupTemplateResponse
): InterventionGroupTemplateRequest {
  return {
    id: g.id,
    name: g.name,
    icon: g.icon,
    order: g.order,
    barSize: g.barSize,
    reimbursementAmount: g.reimbursementAmount,
    patientType: g.patientType,
    interventions: g.interventions.map(interventionResponseToCloneRequest),
    placementRules: g.placementRules
  };
}

function weekResponseToRequest(w: TreatmentWeekTemplateResponse): TreatmentWeekTemplateRequest {
  return {
    weekNumber: w.weekNumber,
    groups: w.groups.map(groupResponseToRequest)
  };
}

export function buildDuplicateRequest(
  source: TreatmentPlanTemplateResponse,
  newName: string
): CreateTreatmentPlanTemplateRequest {
  return {
    name: newName,
    strokeColor: source.strokeColor,
    fillColor: source.fillColor,
    highlightColor: source.highlightColor,
    icon: source.icon,
    locationIds: source.locationIds,
    global: source.global,
    weeks: source.weeks.map(weekResponseToRequest)
  };
}
